


















import { Component, Inject, Vue } from "vue-property-decorator";

import UserInfoRepository from "@/modules/account/user-info.repository";
import User from "@/modules/account/user.model";
import UserInfo from "@/modules/account/user-info.model";

@Component({
  components: {},
  metaInfo: {},
})
export default class AccountMenu extends Vue {
  @Inject("UserInfoRepository")
  private userInfoRepository!: UserInfoRepository;

  private fUser: User;
  private fUserInfo?: UserInfo;

  get userInfo(): UserInfo | undefined {
    return this.fUserInfo;
  }

  constructor() {
    super();

    this.fUser = this.$auth.user()!;
  }

  public logout() {
    this.$auth.logout({
      makeRequest: false,
    });
  }

  protected data() {
    return {
      fUserInfo: this.fUserInfo,
    };
  }

  protected async created() {
    this.fUserInfo = await this.userInfoRepository.getById(this.fUser.id);
  }
}
